<tax-modal-header>menu.cto</tax-modal-header>

<tax-modal-content>
  <tax-input
    [formControl]="filter"
    placeholder="cto.modal.cto.placeholder"
    [autofocus]="true"
    data-qa-input="search"
  ></tax-input>

  <div class="drop-down-list">
    <tax-search-dropdown-list
      id="model"
      data-qa-select="kkm-models"
      placeholder="search.dropdown.kkm.placeholder"
      [data]="kkmInisModels$ | async"
      [currentItem]="'cto.add.models.all'"
      (submittedData)="selectModel($event)"
    ></tax-search-dropdown-list>
  </div>

  <div class="modal-body-wrapper">
    <div class="modal_body" taxScrollbar>
      <div
        class="block"
        *ngIf="filteredList$ | async as ctos; else loading"
        data-qa-block="cto-list"
      >
        <ng-container *ngIf="ctos.length; else empty">
          <div *ngFor="let cto of ctos" data-qa="cto-item">
            <label class="checkbox-container">
              <span class="bold-text" data-qa="cto-name">{{ cto.name }}</span>
              <input
                [value]="cto.iinOrBin"
                [(ngModel)]="defaultSelectedCto"
                (change)="onRadioButtonChange(cto)"
                type="radio"
                name="radio"
                data-qa-radio="cto"
              />
              <span class="checkmark"></span>
            </label>
            <div class="description grey-text">
              <div>
                <span data-qa="iin-bin">{{ cto.iinOrBin }}</span>
                <span data-qa="address">{{ cto.address }}</span>
                <span data-qa="contacts">{{ cto.contacts }}</span>
              </div>
              <p class="text-block centering-string" data-qa-button="toggle-models-visibility">
                <!--TODO: fix $any-->
                <span
                  (click)="$any(cto).visible = !$any(cto).visible"
                  translate
                  data-qa="kkm-models-title"
                  >cto.info.kkm.models</span
                >
                <!--TODO: fix $any-->
                <svg-icon
                  (click)="$any(cto).visible = !$any(cto).visible"
                  [key]="$any(cto).visible ? 'expand-less' : 'expand-more'"
                  class="kkm-model-toggle"
                ></svg-icon>
              </p>
              <!--TODO: fix $any-->
              <div *ngIf="$any(cto).visible" data-qa="kkm-models">
                <ng-container
                  *ngFor="let model of getServicedModels(cto.servicedModels); last as isLast"
                >
                  {{ model }}<ng-container *ngIf="!isLast">,</ng-container>
                </ng-container>
              </div>
            </div>
            <hr class="greyline_block" />
          </div>
        </ng-container>
        <ng-template #empty>
          <div class="block-center" translate data-qa="empty-cto-list-text">
            cto.modal.not.found
          </div>
        </ng-template>
      </div>
      <ng-template #loading>
        <div class="loader-body">
          <div class="loader-block">
            <div class="loader-block-text" translate>cto.modal.loading</div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</tax-modal-content>

<tax-modal-footer>
  <button data-qa-button="close-modal" class="button_link" (click)="closeModal()" translate>
    button.cancel
  </button>
  <button data-qa-button="save" class="button_blue" (click)="saveSelectedCto()" translate>
    modal.select
  </button>
</tax-modal-footer>
